import React from 'react';

const NotesEmptySearch: React.FC = () => {
  return (
    <div className="flex items-center justify-center py-20 text-center">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        No notes match your search.
      </p>
    </div>
  );
};

export default NotesEmptySearch;

